import { Component } from '@angular/core';

@Component({
  selector: 'app-tos',
  standalone: true,
  imports: [],
  templateUrl: './tos.component.html',
  styleUrl: './tos.component.scss'
})
export class TosComponent {
  organization = {
    printable_name: "RoRender",
    email: "support@rorender.com"
  }
}
